import { configureStore } from "@reduxjs/toolkit";
import dialogSlice from "../components/dialog/dialogSlice";
import loginReducer from "../features/login/loginSlice";
import countrySlice from "../features/country/countrySlice";
import promocodeSlice from "../features/promocode/promocodeSlice";
import giftcodeSlice from "../features/giftcode/giftcodeSlice";
import membershipplanSlice from "../features/membershipplan/membershipplanSlice";
import userSlice from "../features/user/userSlice";
import menuSlice from "../features/menu/menuSlice";
import rightsSlice from "../features/rights/rightsSlice";
import userTypeSlice from "../features/userType/userTypeSlice";
import citySlice from "../features/city/citySlice";
import stateSlice from "../features/state/stateSlice";
import muiDrawerSlice from "../components/drawer/drawerSlice";
import nationalitySlice from "../features/nationality/nationalitySlice";
import flightPlaceSlice from "../features/FlightPlace/flightPlaceSlice";
import paginationSlice from "../features/pagination/paginationSlice";
import userManagementSlice from "../features/userManagement/userManagementSlice";
import flightBookingSlice from "../features/flightBooking/flightBookingSlice";
import adminsettingSlice from "../features/adminsetting/adminsettingSlice";
import abandonedFlightBookingSlice from "../features/abandonedFlightBooking/abandonedFlightBookingSlice";
import flightBookingCancellationSlice from "../features/flightbookingcancellation/flightBookingCancellationSlice";
import adminWalletUserSlice from "../features/adminwalletuser/adminWalletUserSlice";
import walletWithdrawalSlice from "../features/walletwithdrawal/walletWithdrawalSlice";
import walletamountreturnSlice from "../features/walletamountreturn/walletamountreturnSlice";
import specialityTypeSlice from "../features/specialitytype/specialityTypeSlice";
import roomTypeSlice from "../features/roomtype/roomTypeSlice";
import regionSlice from "../features/region/regionSlice";
import sectorSlice from "../features/sector/sectorSlice";
import itinerarySlice from "../features/itinerary/itinerarySlice";
import itineraryfacilitySlice from "../features/ItineraryFacility/itineraryfacilitySlice";
import vehicleSharingPaxSlice from "../features/vehiclesharingpax/vehicleSharingPaxSlice";
import dashboardSlice from "../features/dashboard/dashboardSlice";
import tourSlice from "../features/tour/tourSlice";
import gstSlice from "../features/gst/gstSlice";
import currencySlice from "../features/currency/currencySlice";
import inquirySlice from "../features/inquiry/inquirySlice";
import tourserviceSlice from "../features/tourservice/tourserviceSlice";
import logsSlice from "../features/logs/logsSlice";
import bankSlice from "../features/bank/bankSlice";
import bankAccountSlice from "../features/bankaccount/bankaccountSlice";
import topupRequestSlice from "../features/topuprequest/topupRequestSlice";
import cmsSlice from "../features/cms/cmsSlice";
import settingSlice from "../features/setting/settingSlice";

const store = configureStore({
  reducer: {
    login: loginReducer,
    dialog: dialogSlice,
    drawer: muiDrawerSlice,
    nationality: nationalitySlice,
    country: countrySlice,
    promocode: promocodeSlice,
    giftcode: giftcodeSlice,
    membershipplan: membershipplanSlice,
    city: citySlice,
    state: stateSlice,
    user: userSlice,
    adminsetting: adminsettingSlice,
    walletamountreturn: walletamountreturnSlice,
    userM: userManagementSlice,
    menu: menuSlice,
    rights: rightsSlice,
    userType: userTypeSlice,
    flightPlace: flightPlaceSlice,
    flightBooking: flightBookingSlice,
    pagination: paginationSlice,
    abandonedFlightBooking: abandonedFlightBookingSlice,
    flightbookingcancellation: flightBookingCancellationSlice,
    adminWalletUser: adminWalletUserSlice,
    walletWithdrawal: walletWithdrawalSlice,
    specialityType: specialityTypeSlice,
    roomType: roomTypeSlice,
    region: regionSlice,
    sector: sectorSlice,
    itinerary: itinerarySlice,
    itineraryfacility: itineraryfacilitySlice,
    vehicleSharingPax: vehicleSharingPaxSlice,
    dashboard: dashboardSlice,
    tour: tourSlice,
    gst: gstSlice,
    currency: currencySlice,
    inquiry: inquirySlice,
    tourservice: tourserviceSlice,
    log: logsSlice,
    bank: bankSlice,
    bankaccount: bankAccountSlice,
    topuprequest: topupRequestSlice,
    cms: cmsSlice,
    setting: settingSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
